import { is, getType } from "../utilities/is-type";
var attributeToPropertyNames = {};
var propertyNamesToAttributes = {};
function attributeToPropertyName(attribute) {
    var property = attributeToPropertyNames[attribute];
    if (!property) {
        // Convert and memoize.
        var hypenRegEx = /-([a-z])/g;
        property = attribute.replace(hypenRegEx, function (match) { return match[1].toUpperCase(); });
        attributeToPropertyNames[attribute] = property;
    }
    return property;
}
function propertyNameToAttribute(property) {
    var attribute = propertyNamesToAttributes[property];
    if (!attribute) {
        // Convert and memoize.
        var uppercaseRegEx = /([A-Z])/g;
        attribute = property.replace(uppercaseRegEx, "-$1").toLowerCase();
        propertyNamesToAttributes[property] = attribute;
    }
    return attribute;
}
function property(value) {
    var transform;
    switch (getType(value)) {
        case "string":
            transform = String;
            break;
        case "number":
            transform = Number;
            break;
        case "boolean":
            transform = Boolean;
            break;
        case "function":
            transform = value;
            value = transform();
            break;
        case "object":
            transform = function (value) { return Object.freeze(value); };
            break;
        case "array":
            transform = function (value) { return [].concat(value); };
            break;
        default:
            transform = function (v) { return v; };
            break;
    }
    return {
        get: function (host, val) {
            if (val === void 0) { val = value; }
            return val;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        set: function (host, val, oldValue) { return transform(val); },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        connect: function (host, key, invalidate) {
            if (host[key] === value && (is.number(value) || is.string(value) || is.boolean(value))) {
                var attrName = propertyNameToAttribute(key);
                if (host.hasAttribute(attrName)) {
                    var attrValue = host.getAttribute(attrName);
                    if (attrValue === "") {
                        host[key] = true;
                    }
                    else {
                        host[key] = attrValue;
                    }
                }
            }
        }
    };
}
export { property, propertyNameToAttribute, attributeToPropertyName };
//# sourceMappingURL=property.js.map